export default __webpack_public_path__ + "static/media/mfh_icon.bd8dee68.svg";